// User-facing error messages. Persian only for now: they can move into i18n later.
export const AUTH_MESSAGES = {
    nameRequired: "لطفاً نام را وارد کنید.",
    phoneRequired: "لطفاً شماره تلفن همراه را وارد کنید.",
    captchaRequired: "لطفاً reCAPTCHA را تکمیل کنید.",
    otpRequired: "لطفاً کد تایید را وارد کنید.",
    otpFailed: "ارسال کد تایید انجام نشد.",
    authFailed: "احراز هویت انجام نشد.",
    generic: "خطایی رخ داد. لطفاً دوباره تلاش کنید."
};